import {
  drawerWidth,
  drawerMiniWidth,
  transition,
  containerFluid,
} from "assets/jss/material-dashboard-pro-react.js";

const appStyle = (theme) => ({
  wrapper: {
    backgroundColor: "#e6e5eb",
    position: "relative",
    top: "0",
    fontFamily: '"Source Sans Pro",sans-serif',
    height: "100vh",
    "&:after": {
      display: "table",
      clear: "both",
      content: '" "',
    },
  },
  mainPanel: {
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    '@media (min-width:900px)': {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch",
    backgroundColor: "#e6e5eb",
  },
  content: {
    marginTop: "0",
    padding: "0px 0px",
    minHeight: "100vh",
    backgroundColor: "#E6E5EB"
  },
  container: { ...containerFluid },
  map: {
    marginTop: "70px",
  },
  mainPanelSidebarMini: {
    '@media (min-width:900px)': {
      width: `calc(100% - ${drawerMiniWidth}px)`,
      //width: `calc(100% - 350px)`
    },
  },
  mainPanelMenuEntitesActive: {
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    '@media (min-width:900px)': {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch",
  },
  mainPanelSidebarMiniMenuEntitesActive: {
    '@media (min-width:900px)': {
      //width: `calc(100% - ${drawerMiniWidth}px)`,
      width: `calc(100% - 350px)`,
    },
  },
  mainPanelWithPerfectScrollbar: {
    overflow: "hidden !important",
  },
  mainDivMenuEntitesInactive: {
    display: 'none',
  },
  mainDivMenuEntitesActive: {
    display: 'block',
  }
});

export default appStyle;
